<template>
  <div class="stage">
    <iframe class="phone" :src="src" frameborder="0" />
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from "vue";

// 这里改成你的移动端入口
const src = computed(() => "/guifan/startup");

// 进入预览页：禁止外层页面滚动；离开恢复
onMounted(() => {
  document.documentElement.classList.add("preview-no-scroll");
  document.body.classList.add("preview-no-scroll");
});
onBeforeUnmount(() => {
  document.documentElement.classList.remove("preview-no-scroll");
  document.body.classList.remove("preview-no-scroll");
});
</script>

<style scoped>
/* 外层舞台：固定一屏，不允许滚动 */
.stage {
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  padding: 12px;         /* 这个不要太大，否则小屏会撑出外层滚动 */
  box-sizing: border-box;
}

/* iframe “手机窗口”：限制在视口内，避免撑出外层滚动 */
.phone {
  width: 390px;
  height: 844px;

  /* 关键：不超过当前视口 */
  max-width: 100%;
  max-height: 100%;

  background: #fff;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  display: block; /* 避免 iframe 默认 inline 带来的底部空隙 */
}

/* 真手机打开就全屏 */
@media (max-width: 430px) {
  .stage {
    padding: 0;
    background: #fff;
  }
  .phone {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
  }
}
</style>
